import SvgIcoCloud from './SvgIcoCloud';

export default SvgIcoCloud;
